import script from "./TumorBoardUpcomingSession.vue?vue&type=script&setup=true&lang=js"
export * from "./TumorBoardUpcomingSession.vue?vue&type=script&setup=true&lang=js"

import "./TumorBoardUpcomingSession.vue?vue&type=style&index=0&id=bf6728d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf6728d0"]])

export default __exports__